export const newsList = [
  {
    id: "n01",
    title: "湖人主场险胜勇士，末节防守强度决定胜负",
    summary: "湖人在加密竞技场球馆以微弱优势击败勇士，第四节最后六分钟的防守强度成为本场比赛的转折点。",
    category: "赛事战报",
    author: "陈子航",
    publishTime: "2026-10-09 08:45",
    image: "https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20action%20shot%20two%20players%20contesting%20near%20the%20rim%20inside%20a%20bright%20modern%20arena%20with%20crowd%20blurred%20in%20background%2C%20dramatic%20sports%20photography%2C%20high%20detail&width=800&height=500&seq=nba-news-01&orientation=landscape",
    content: [
      "北京时间今日上午，NBA常规赛继续进行，洛杉矶湖人在主场迎战金州勇士。最终湖人凭借末节关键阶段的防守强度笑到最后，将本赛季战绩提升至 4 胜 1 负。",
      "比赛前三节两队比分交替领先，勇士依靠外线三分一度建立优势，而湖人则通过内线强攻与快速反击紧咬比分。进入第四节后，湖人明显提升了防守的强度与轮转速度，迫使对手在进攻端出现多次失误。",
      "赛后湖人主教练在采访中表示，球队在防守端的沟通是取胜的关键，尤其是最后六分钟的换防执行得非常到位。勇士方面则认为球队的篮板保护仍有提升空间。",
      "本场过后，两队将在接下来的赛程中继续面对西部强敌，排名争夺依然激烈。",
    ],
    relatedIds: ["n02", "n05", "n09"],
  },
  {
    id: "n02",
    title: "掘金雷霆西北赛区内战，内线对抗成为焦点",
    summary: "掘金坐镇波尔球馆迎战雷霆，两队内线核心的低位对抗与外线射手群的火力比拼构成本场最大看点。",
    category: "赛前前瞻",
    author: "李沐阳",
    publishTime: "2026-10-09 07:20",
    image: "https://readdy.ai/api/search-image?query=Basketball%20players%20jumping%20for%20a%20rebound%20under%20the%20basket%20in%20a%20packed%20indoor%20arena%2C%20warm%20spotlight%20and%20energetic%20atmosphere%2C%20sports%20editorial%20photography%2C%20crisp%20detail&width=800&height=500&seq=nba-news-02&orientation=landscape",
    content: [
      "西部西北赛区内战本场打响，丹佛掘金将在主场波尔球馆迎战俄克拉荷马雷霆。两队近几个赛季多次交手，比赛强度一直居高不下。",
      "掘金以内线策应和高位挡拆为核心打法，强调半场阵地中的耐心传导；雷霆则更依赖年轻阵容的冲击力与快速转换。谁能控制篮板，谁就更有可能掌握比赛节奏。",
      "值得注意的是，两队本赛季的三分命中率均处于联盟前列，外线射手群的发挥将直接影响比分走势。",
    ],
    relatedIds: ["n01", "n06", "n10"],
  },
  {
    id: "n03",
    title: "凯尔特人尼克斯东部强强对话前瞻",
    summary: "凯尔特人主场迎战尼克斯，两支东部争冠热门球队的碰撞被看作本赛季东部格局的重要参照。",
    category: "赛前前瞻",
    author: "王清源",
    publishTime: "2026-10-09 06:50",
    image: "https://readdy.ai/api/search-image?query=Two%20basketball%20teams%20lined%20up%20for%20tip%20off%20in%20a%20huge%20arena%20with%20green%20court%20markings%2C%20dynamic%20lighting%2C%20wide%20angle%20sports%20photography%2C%20sharp%20detail&width=800&height=500&seq=nba-news-03&orientation=landscape",
    content: [
      "东部大西洋赛区的强强对话今晚在 TD 花园球馆上演，波士顿凯尔特人主场迎战纽约尼克斯。",
      "两支球队都被视为东部冠军的有力竞争者，本场比赛的攻防效率对比将成为评估双方实力的重要参考。凯尔特人的团队传导与尼克斯的强硬防守之间的博弈值得期待。",
      "从近期状态看，双方都在寻找最佳轮换组合，替补阵容的贡献很可能决定比赛的最后走向。",
    ],
    relatedIds: ["n04", "n08", "n11"],
  },
  {
    id: "n04",
    title: "76人主场力克热火，关键时刻罚球稳定军心",
    summary: "76人在富国银行中心球馆以 112:108 战胜热火，终场前的稳定罚球帮助主队守住胜果。",
    category: "赛事战报",
    author: "陈子航",
    publishTime: "2026-10-09 06:10",
    image: "https://readdy.ai/api/search-image?query=Basketball%20player%20shooting%20a%20free%20throw%20in%20a%20bright%20arena%20with%20fans%20in%20the%20background%2C%20focused%20expression%2C%20clean%20sports%20photography%2C%20high%20detail&width=800&height=500&seq=nba-news-04&orientation=landscape",
    content: [
      "费城 76 人在主场以 112:108 击败迈阿密热火，取得一场含金量十足的胜利。",
      "比赛最后阶段，热火一度将分差缩小到 2 分，但 76 人后卫稳稳罚中两球，稳住局面。终场前热火的压哨三分偏出，客队遗憾告负。",
      "76 人本场在防守篮板与二次进攻上占据优势，这也是球队能够在关键回合保持领先的重要原因。",
    ],
    relatedIds: ["n03", "n07", "n12"],
  },
  {
    id: "n05",
    title: "本赛季三分潮流继续升温，多队外线出手创新高",
    summary: "新赛季开赛以来，联盟多支球队的三分出手占比进一步提升，外线火力正在重塑比赛的节奏与空间。",
    category: "数据解读",
    author: "赵一鸣",
    publishTime: "2026-10-08 21:30",
    image: "https://readdy.ai/api/search-image?query=Basketball%20player%20releasing%20a%20three%20point%20shot%20silhouetted%20against%20bright%20arena%20lights%2C%20motion%20blur%20energy%2C%20editorial%20sports%20photography%2C%20vivid&width=800&height=500&seq=nba-news-05&orientation=landscape",
    content: [
      "新赛季开始以来，联盟的整体三分出手占比继续走高，越来越多的球队选择用外线投射拉开空间。",
      "从数据层面看，多支球队的单场三分出手数已经突破 45 次，快速传导球后的空位三分成为常规战术之一。这种趋势让比赛的节奏更快，也对防守端的轮转提出更高要求。",
      "不过，也有教练提醒，过度依赖外线会带来命中率波动，如何在内外线之间取得平衡，仍是各队需要长期解决的问题。",
    ],
    relatedIds: ["n02", "n06", "n09"],
  },
  {
    id: "n06",
    title: "年轻核心全面爆发，多支重建球队迎来上升期",
    summary: "雷霆、马刺等球队的年轻核心本赛季持续进步，联盟的年轻势力正在以实际行动改写格局。",
    category: "深度分析",
    author: "李沐阳",
    publishTime: "2026-10-08 19:15",
    image: "https://readdy.ai/api/search-image?query=Young%20basketball%20players%20celebrating%20together%20on%20the%20court%20in%20a%20bright%20modern%20arena%2C%20teammates%20huddle%2C%20uplifting%20sports%20photography%2C%20high%20detail&width=800&height=500&seq=nba-news-06&orientation=landscape",
    content: [
      "本赛季开赛以来，联盟中最引人关注的趋势之一，是几支年轻球队的快速成长。",
      "雷霆与马刺等球队围绕年轻核心搭建体系，在攻防两端都展现出超出年龄的成熟度。快速的攻防转换、积极的无球跑动，让这些球队的比赛风格充满活力。",
      "分析人士认为，这些球队的上限依然很高，随着赛季深入，他们的表现将持续影响季后赛席位的争夺。",
    ],
    relatedIds: ["n02", "n05", "n10"],
  },
  {
    id: "n07",
    title: "热火防守体系再升级，团队协作成最大武器",
    summary: "迈阿密热火延续一贯的团队防守传统，本赛季在换防与协防轮转上展现出更高的执行效率。",
    category: "深度分析",
    author: "王清源",
    publishTime: "2026-10-08 16:40",
    image: "https://readdy.ai/api/search-image?query=Basketball%20defenders%20in%20a%20tight%20zone%20formation%20on%20polished%20hardwood%20court%2C%20intense%20competitive%20moment%2C%20sports%20photography%2C%20clean%20composition&width=800&height=500&seq=nba-news-07&orientation=landscape",
    content: [
      "迈阿密热火一直是联盟中以团队防守著称的球队，本赛季他们在换防与协防轮转上的执行效率进一步提升。",
      "球队强调防守的整体性，每一名球员都需要清晰了解自己的轮转职责。这种体系在面对拥有强力得分手的对手时，往往能有效限制对方的进攻效率。",
      "尽管进攻端的稳定性仍有起伏，但稳定的防守让热火始终保持竞争力。",
    ],
    relatedIds: ["n04", "n11", "n12"],
  },
  {
    id: "n08",
    title: "东部格局初现端倪，多队竞争激烈排名胶着",
    summary: "开赛阶段东部的排名竞争异常激烈，凯尔特人、尼克斯、雄鹿等球队之间的差距十分有限。",
    category: "深度分析",
    author: "赵一鸣",
    publishTime: "2026-10-08 14:05",
    image: "https://readdy.ai/api/search-image?query=Wide%20view%20of%20a%20packed%20basketball%20arena%20during%20an%20intense%20game%20with%20scoreboard%20glowing%2C%20dramatic%20atmosphere%2C%20sports%20photography%2C%20high%20detail&width=800&height=500&seq=nba-news-08&orientation=landscape",
    content: [
      "随着常规赛的推进，东部联盟的竞争格局逐渐清晰，但排名依然十分胶着。",
      "凯尔特人、尼克斯、雄鹿等球队都展现出争冠级的实力，彼此之间并没有明显差距。一场比赛的胜负，往往就能让排名发生较大变化。",
      "可以预见，本赛季东部的季后赛席位争夺将会异常激烈。",
    ],
    relatedIds: ["n03", "n07", "n11"],
  },
  {
    id: "n09",
    title: "球员伤病动态汇总，多队轮换阵容面临调整",
    summary: "联盟多支球队近期出现不同程度的伤病情况，教练组需要及时调整轮换，以保持阵容的竞争力。",
    category: "伤病动态",
    author: "陈子航",
    publishTime: "2026-10-08 11:50",
    image: "https://readdy.ai/api/search-image?query=Basketball%20player%20sitting%20on%20the%20bench%20with%20a%20towel%2C%20thoughtful%20expression%2C%20blurred%20arena%20background%2C%20moody%20sports%20photography%2C%20natural%20lighting&width=800&height=500&seq=nba-news-09&orientation=landscape",
    content: [
      "近期联盟多支球队受到伤病困扰，部分主力球员需要短暂休战，球队轮换阵容随之调整。",
      "教练组表示，伤病是漫长赛季的一部分，如何合理安排球员出场时间、保护核心球员的健康，是球队必须面对的课题。",
      "球迷们也在关注效力球队的伤病报告，期待球员尽快康复回归赛场。",
    ],
    relatedIds: ["n01", "n05", "n06"],
  },
  {
    id: "n10",
    title: "新秀赛季观察：多位新秀快速融入球队体系",
    summary: "本赛季的多位新秀在开赛阶段就获得稳定出场时间，并用表现证明了自己的适应能力。",
    category: "新秀观察",
    author: "李沐阳",
    publishTime: "2026-10-07 20:30",
    image: "https://readdy.ai/api/search-image?query=Rookie%20basketball%20player%20driving%20to%20the%20hoop%20with%20determination%20in%20a%20bright%20arena%2C%20dynamic%20motion%2C%20sports%20photography%2C%20sharp%20detail&width=800&height=500&seq=nba-news-10&orientation=landscape",
    content: [
      "本赛季多位新秀在开赛阶段就赢得了教练组的信任，获得了可观的出场时间。",
      "他们中的不少人展现出了超越年龄的阅读比赛能力，在攻防两端都能够做出贡献。快速的适应能力，也让球队的重建进程更加顺畅。",
      "随着赛季的深入，这些新秀的成长轨迹将继续成为球迷关注的焦点。",
    ],
    relatedIds: ["n06", "n05", "n09"],
  },
  {
    id: "n11",
    title: "雄鹿骑士东部内战，内线攻防成为胜负手",
    summary: "雄鹿主场迎战骑士，两队都拥有出色的内线球员，禁区之争很可能直接决定比赛的最后走向。",
    category: "赛前前瞻",
    author: "王清源",
    publishTime: "2026-10-07 17:10",
    image: "https://readdy.ai/api/search-image?query=Basketball%20center%20posting%20up%20near%20the%20paint%20in%20a%20dimly%20lit%20arena%20with%20spotlights%2C%20intense%20moment%2C%20sports%20photography%2C%20moody&width=800&height=500&seq=nba-news-11&orientation=landscape",
    content: [
      "东部中部赛区的强强对话即将上演，密尔沃基雄鹿主场迎战克利夫兰骑士。",
      "两队都拥有出色的内线球员，禁区的攻防对抗很可能成为比赛的胜负手。同时，双方的外线投射稳定性也将影响比赛的节奏。",
      "对于两支志在冲击东部前列的球队而言，本场比赛的重要性不言而喻。",
    ],
    relatedIds: ["n03", "n08", "n07"],
  },
  {
    id: "n12",
    title: "联盟规则调整解读：比赛节奏与判罚尺度有何变化",
    summary: "新赛季联盟对部分比赛规则进行了微调，旨在提升比赛观赏性的同时，保持判罚尺度的一致性。",
    category: "规则解读",
    author: "赵一鸣",
    publishTime: "2026-10-07 12:00",
    image: "https://readdy.ai/api/search-image?query=Basketball%20referee%20signaling%20on%20the%20court%20in%20a%20packed%20arena%2C%20authoritative%20pose%2C%20sports%20photography%2C%20clean%20detail&width=800&height=500&seq=nba-news-12&orientation=landscape",
    content: [
      "新赛季联盟对部分比赛规则进行了微调，涉及比赛节奏、暂停使用以及判罚尺度等多个方面。",
      "从开赛情况看，这些调整在一定程度上加快了比赛的流畅度，也让教练组在战术布置上有了新的考量。",
      "联盟表示，将继续观察规则执行效果，并根据实际情况进行必要的完善，以保障比赛的公平性与观赏性。",
    ],
    relatedIds: ["n04", "n07", "n08"],
  },
];